/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.setGridHeight = (selector) => {
    this.heightArray = [];
    this.offsetArrayArray = [];
    this.sectionArray = [];
    document.querySelectorAll(selector).forEach((grid, i) => {
        var tmp = {
            'index': i,
            'offsetheight': grid.closest(`[data-equal]`).offsetTop
        };

        this.offsetArrayArray.push(tmp)
    });

    this.diffrentsHeights = []
    this.offsetArrayArray.forEach(function(e) {
        if (this.diffrentsHeights.includes(e.offsetheight) == false) {
            this.diffrentsHeights.push(e.offsetheight)
        }
    })

    this.diffrentsHeights.forEach(function(e) {
        var data = [];
        for (var i = 0; i < this.offsetArrayArray.length; i++) {
            if (this.offsetArrayArray[i].offsetheight == e) {
                data.push(this.offsetArrayArray[i]);
            }
        }

        var getAllHeightArray = [];
        data.forEach(function(ele) {
            document.querySelectorAll(selector)[ele.index].removeAttribute('style');
            getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
        })

        var getMaxHeight = (Math.max.apply(Math, getAllHeightArray)) + 1;
        data.forEach(function(ele) {
            // console.log(document.querySelectorAll(selector)[ele.index])
            document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight + 'px';
        });

    });
}

class updateQty extends HTMLElement {
  constructor(){
    super();
    this.button = this.querySelectorAll(".quantity-selector__button");
    this.inputElement = this.querySelector("input[name='quantity']");
    this.button.forEach(btn => { 
      btn.addEventListener("click", this.changeQtyUsingButtons.bind(this));
    });
    this.inputElement.addEventListener("keyup", debounce(this.changeQtyUsingInput.bind(this), 600));
  }

  changeQtyUsingInput(event){
    if(this.checkVariantSelected(event) == false){
      return;
    }
    
    if(event.target.closest(".card__section")){
      if(event.target.closest(".quantity-selector").querySelector("button").classList.contains("change_quantity")){
        if(event.target.value != '' && parseInt(event.target.value) > 0){
          this.addToCart(event, 'inputbox');
        }
      }
    }else{
      if(event.target.value != '' && parseInt(event.target.value) > 0){
        if(event.target.closest(".quantity-selector").querySelector("button").classList.contains("change_quantity")){
          this.addToCart(event, 'inputbox');
        } 
      }
    }

      
    /*if(event.target.value != '' && parseInt(event.target.value) > 0){
      this.addToCart(event, 'inputbox');
    }*/
  }
  
  changeQtyUsingButtons(event){
    if(this.checkVariantSelected(event) == false){
      return;
    }
    
    if(event.target.dataset.action == 'increase-picker-quantity'){
      var val = this.inputElement.value;
      
      if(event.target.closest(".card__section")){
        this.inputElement.value = parseInt(val) + 1;
        if(event.target.classList.contains("change_quantity")){
          this.addToCart(event);
        }
      }else{
        this.inputElement.value = parseInt(val) + 1;
        if(event.target.classList.contains("change_quantity")){
          this.addToCart(event);
        }
      }
      
      /*let val = this.inputElement.value;
      this.inputElement.value = parseInt(val) + 1;
      if(event.target.classList.contains("change_quantity")){
        this.addToCart(event);
      }*/
      
    }else{
      var minVal = this.inputElement.value;

      if(event.target.closest(".card__section")){
        this.inputElement.value = Math.max(1, parseInt(minVal) - 1);
        if(event.target.classList.contains("change_quantity")){
          if(minVal > 1){
            this.addToCart(event);
          } 
        }
      }else{
        this.inputElement.value = Math.max(1, parseInt(minVal) - 1);
        if(minVal > 1 && event.target.classList.contains("change_quantity")){
          this.addToCart(event);
        }
      }
      
      /*let minVal = this.inputElement.value;
      this.inputElement.value = Math.max(1, parseInt(minVal) - 1);
      if(minVal > 1 && event.target.classList.contains("change_quantity")){
        this.addToCart(event);
      }*/
      
    }
  }

  addToCart(event, target=""){
    if (window.theme.cartType === 'page') {
      return; // When using a cart type of page, we just simply redirect to the cart page
    }

    if(this.checkVariantSelected(event) == false){
      return; // When variant are not selected
    }

    if(event.target.closest(".product-item")){
      var formElement = event.target.closest(".product-item").querySelector('form[action*="/cart/add"]');
      var newQty = event.target.closest(".product-item").querySelector("qty-selector").querySelector(".colle-grid-quantity").value;
    }else{
      var formElement = event.target.closest(".card__section").querySelector('form[action*="/cart/add"]');
      var newQty = event.target.closest(".card__section").querySelector("qty-selector").querySelector(".quantity-selector__value").value;
    }
    
    //let formElement = event.target.closest(".product-item").querySelector('form[action*="/cart/add"]');
    let newArr = this.checkVariantSelected(event);

    
    if(newQty){
      newArr['quantity'] = newQty; //Update new quantity
    }
    var _this = $(this);
    fetch("".concat(window.routes.cartChangeUrl, ".js"), {
      body: JSON.stringify(newArr),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

      }
    }).then(function (response) {
      if(response.ok){
        if(event.target.dataset.action == 'increase-picker-quantity' || target == 'inputbox'){
          event.target.closest(".card__section") ? addImageInCart(_this, 1) : addImageInCart(_this);
        }else if(event.target.dataset.action == 'decrease-picker-quantity'){
          removeImageFromCart(_this);
        }

        //Update quantity in select box 'data-value' which are added in cart
        if(formElement.querySelector("select.product-variant-select")){
          formElement.querySelector("select.product-variant-select option[value='"+newArr['id']+"']").setAttribute("data-value", newArr['quantity']);
        }
        
        fetch("/")
        .then(resp => { return resp.text() })
        .then(responseData => {
          let parseHTML = new DOMParser().parseFromString(responseData, "text/html");
          let newHeaderCartCount = parseHTML.querySelector(".header__cart-count");
          let oldHeaderCartCount = document.querySelector(".header__cart-count");
          let newCartDrawer = parseHTML.querySelector("#mini-cart");
          let oldCartDrawer = document.querySelector("#mini-cart");
          if(newHeaderCartCount && oldHeaderCartCount){
            oldHeaderCartCount.innerHTML = newHeaderCartCount.innerHTML;
          }
          if(newCartDrawer && oldCartDrawer){
            oldCartDrawer.innerHTML = newCartDrawer.innerHTML;
          }
        });
      }else{
        response.json().then(function(resp) {
          if(resp['status'] == 422){
            if(event.target.closest(".product-item")){
              var dropdownList = formElement.querySelector("select.product-variant-select");
              if(dropdownList){
                var qty = dropdownList.options[dropdownList.selectedIndex].dataset.qty;
              }else{
                var qty = formElement.querySelector(".single_var_pro").dataset.qty;
              }
            }else if(event.target.closest(".card__section")){
              var qty = formElement.querySelector(".quantity-selector__value").dataset.qty;
            }
            
            if(qty){
              var currLocate = Shopify.locale
              var stockMsg = ''
              if(currLocate == 'es'){
                if (qty == 1) {
                    stockMsg = "Solo disponemos de " +qty+ " unidad";
                } else {
                    stockMsg = "Solo disponemos de "+qty+" unidades";
                }
              }else if(currLocate == 'ca'){
                if (qty == 1) {
                    stockMsg = "Només disposem de "+qty+" unitat";
                } else {
                    stockMsg = "Només disposem de "+qty+" unitats";
                }
              }else if(currLocate == 'en'){
                if (qty == 1) {
                    stockMsg = "We only have "+qty+"pc in stock";
                } else {
                    stockMsg = "We only have "+qty+"pcs in stock";
                }                
              }

              if(event.target.closest(".product-item")){
                formElement.querySelector(".stock-err").innerHTML = stockMsg;
                formElement.querySelector(".stock-err").style.display = 'block';
                event.target.closest(".product-item").querySelector("qty-selector").querySelector(".colle-grid-quantity").value = qty;
              }else if(event.target.closest(".card__section")) {
                var qtySelector = event.target.closest(".card__section").querySelector("qty-selector");
                if (qtySelector) {
                    var quantityValue = qtySelector.querySelector(".quantity-selector__value");
                    if (quantityValue) {
                        quantityValue.value = qty;
                        if (!document.querySelector('.product-form__status-message')) {
                            var messageElement = document.createElement('div');
                            messageElement.className = 'product-form__status-message';  
                            messageElement.style.height = 'auto';
                            messageElement.innerHTML = "<p class='alert alert--error'>"+stockMsg+"</p>";     
                            formElement.append(messageElement);
                        }
                    }
                }
            }

              // }else if(event.target.closest(".card__section")){
              //   event.target.closest(".card__section").querySelector("qty-selector").querySelector(".quantity-selector__value").value = qty;
              //   var messageElement = document.createElement('div');
              //   messageElement.className = 'product-form__status-message';  
              //   messageElement.style.height = 'auto';
              //   messageElement.innerHTML = "<p class='alert alert--error'>"+stockMsg+"</p>";     
              //   formElement.append(messageElement)
              // }
              
              setTimeout(()=>{
                if(formElement.querySelector(".stock-err")){
                  formElement.querySelector(".stock-err").style.display = 'none';
                }else if(formElement.querySelector(".product-form__status-message")){
                  formElement.querySelector(".product-form__status-message").remove();
                }
              }, 4000);
              
            }
          }
        });
      }
    });
  }

  checkVariantSelected(event){
    if(event.target.closest(".product-item")){
      var formElement = event.target.closest(".product-item").querySelector('form[action*="/cart/add"]');
    }else{
      var formElement = event.target.closest(".card__section").querySelector('form[action*="/cart/add"]');
    }
    
    let data = new FormData(formElement);
    //let newArr = Form(data);
    let newArr = {};
    for (let [key, value] of data) {
      newArr[key] = value;
    }
    
    if(newArr['id'] == 0){
      formElement.querySelector("select.product-variant-select").style.border = '1px solid red';
      setTimeout(()=>{
        formElement.querySelector("select.product-variant-select").style.border = '1px solid #00000030';
      }, 3000);
      return false;
    }else{
      return newArr;
    }
  }
}
customElements.define("qty-selector", updateQty);

function debounce(fn, delay) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

/*function Form(data){
  let obj = {};
  for (let [key, value] of data) {
    obj[key] = value;
  }
  return obj;
}*/

function addImageInCart(obj, is_pro=0){
  var cart = $('.header__cart-toggle');
  if(is_pro == 1){
    if(window.innerWidth <= 640){
      var imgtodrag = obj.parents("section[data-section-type='product']").find(".product-gallery").find(".product-gallery__thumbnail-list a:first").find("img");
    }else{
      var imgtodrag = obj.parents("section[data-section-type='product']").find(".product-gallery").find(".product-gallery__carousel:first").find("img");
    }
  }else{
    var imgtodrag = obj.parents('.product-item').find("img");
  }
  
  if (imgtodrag) {
    var imgclone = imgtodrag.clone()
    .offset({
      top: imgtodrag.offset().top,
      left: imgtodrag.offset().left
    })
    .css({
      'opacity': '0.9',
      'position': 'absolute',
      'height': 'auto',
      'width': 'auto',
      'z-index': '100'
    })
    .appendTo($('body'))
    .animate({
      'top': cart.offset().top + 10,
      'left': cart.offset().left + 10,
      'width': 15,
      'height': 15
    }, 600);

    imgclone.animate({
      'width': 10,
      'height': 10
    }, function () {
      $(this).detach()
    });
  }
}

function removeImageFromCart(obj){
  var cart = $('.header__cart-toggle');

  if(obj.parents('.product-item').length > 0){
    var imgtodrag = obj.parents('.product-item').find(".product-item__image-wrapper").find("img");
  }else if(obj.parents('.card__section').length > 0){
    if(window.innerWidth <= 640){
      var imgtodrag = obj.parents("section[data-section-type='product']").find(".product-gallery").find(".product-gallery__thumbnail-list a:first").find("img");
    }else{
      //console.log(obj.parents("section[data-section-type='product']").find(".product-gallery").find("img").eq(0))
      var imgtodrag = obj.parents("section[data-section-type='product']").find(".product-gallery").find(".product-gallery__carousel").find("img.product-gallery__image");
    }
  }
  
  if (imgtodrag) {
    var imgclone = imgtodrag.clone()
    .offset({
      top: cart.offset().top + 10,
      left: cart.offset().left + 10
    })
    .css({
      'opacity': '0.9',
      'position': 'absolute',
      'height': '5px',
      'width': '5px',
      'z-index': '100'
    })
    .appendTo($('body'))
    .animate({
      'top': imgtodrag.offset().top,
      'left': imgtodrag.offset().left,
      'width': imgtodrag.width(),
      'height': imgtodrag.height()
    }, 600);

    imgclone.animate({
      'width': 'auto',
      'height': 'auto'
    }, function () {
      $(this).detach()
    });
  }
}

$(document).on("change", ".product-item select.product-variant-select", function(){
  let cartItem = $(this).find(":selected").attr("data-value");
  if(cartItem > 0){
    $(this).parents(".product-item").find(".colle-grid-quantity").val(cartItem);
    $(this).parents(".product-item").find(".quantity-selector__button").addClass("change_quantity");
    $(this).parents(".product-item").find("button[data-action='add-to-cart']").addClass("added_to_cart");
    $(this).parents(".product-item").find("button[data-action='add-to-cart']").text('En el carrito');
  }else if(cartItem == 0){
    $(this).parents(".product-item").find(".colle-grid-quantity").val(1);
    $(this).parents(".product-item").find(".quantity-selector__button").removeClass("change_quantity");
    $(this).parents(".product-item").find("button[data-action='add-to-cart']").removeClass("added_to_cart");
    $(this).parents(".product-item").find("button[data-action='add-to-cart']").text('Añadir al carrito');
  }
});